import React, { FC, useState, ChangeEvent, useEffect } from 'react';
import { Box, FormControlLabel, Switch } from '@material-ui/core';

interface Props {
  label?: string;
  initialValue?: boolean;
  value?: boolean;
  onChange?: (value: boolean) => void;
}

export const LiabilitySwitch: FC<Props> = ({
  label,
  initialValue = false,
  value,
  onChange
}) => {
  // const classes = useStyles();
  const [checked, setChecked] = useState(initialValue);

  useEffect(() => {
    if (typeof value === 'boolean') {
      setChecked(value);
    }
  }, [value]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    onChange?.(event.target.checked);
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={typeof value === 'boolean' ? value : checked}
            onChange={handleChange}
          />
        }
        label={label}
      />
    </Box>
  );
};
